import styled from 'styled-components';

export const GalleryContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 5px;
  padding: 16px;
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const GalleryItem = styled.img`
  width: 100%;
    height: 150px;
    @media (min-width: 768px) {
        height: 200px;
    }

    @media (min-width: 1024px) {
        height: 250px;
    }
  object-fit: cover;
  border-radius: 8px;
  cursor:pointer;
`;
